import React from 'react';
import PropTypes from 'prop-types';
import styles from './BasicPageHeader.module.css';

const BasicPageHeader = ({ leftChild, rightChild, rightContainerStyle }) => {
  return (
    <div className={styles.container}>
      <div className={styles.leftContainer}>{leftChild}</div>
      <div className={styles.rightContainer} style={rightContainerStyle}>
        {rightChild}
      </div>
    </div>
  );
};

BasicPageHeader.propTypes = {
  leftChild: PropTypes.element,
  rightChild: PropTypes.element,
  rightContainerStyle: PropTypes.object,
};

export default BasicPageHeader;
